import { useTheme } from 'foundations-theming/utils';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HSOCMerchCardLayoutUI = ({
  'data-selenium-id': dataSeleniumId,
  columnStart,
  Badge,
  Title,
  Subheading,
  Pricing,
  Term,
  CTAs,
  Subtext,
  Features,
  Footer,
  cardStyles
}) => {
  const theme = useTheme();
  const layoutProps = {
    gridColumn: `${columnStart} / span 1`
  };
  const {
    backgroundColor,
    showBorder,
    radius,
    borderColor = 'border-core-subtle',
    borderWidth = '100',
    boxShadow,
    customBoxShadow
  } = cardStyles || {};
  let cssBoxShadow;
  if (customBoxShadow) {
    const {
      offsetX,
      offsetY,
      blur,
      spread,
      color
    } = customBoxShadow;
    cssBoxShadow = `${offsetX} ${offsetY} ${blur} ${spread} ${theme.color[color]}`;
  }
  const styleProps = {
    paddingInline: '700',
    backgroundColor,
    borderColor,
    borderWidth,
    borderInlineStartStyle: showBorder ? 'solid' : 'none',
    borderInlineEndStyle: showBorder ? 'solid' : 'none'
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      borderStartStartRadius: radius,
      borderStartEndRadius: radius,
      borderEndStartRadius: radius,
      borderEndEndRadius: radius,
      gridRow: "1 / -1",
      boxShadow: boxShadow,
      cssBoxShadow: cssBoxShadow,
      zIndex: -1
    }, layoutProps)), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Badge",
      position: "relative"
    }, layoutProps, {
      children: Badge
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Title",
      paddingBlockStart: "600",
      position: "relative",
      borderBlockStartStyle: showBorder ? 'solid' : 'none',
      borderStartStartRadius: radius,
      borderStartEndRadius: radius,
      "data-selenium-id": dataSeleniumId
    }, layoutProps, styleProps, {
      children: Title
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Subheading",
      paddingBlockStart: "400"
    }, layoutProps, styleProps, {
      children: Subheading
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Pricing",
      paddingBlockStart: "400"
    }, layoutProps, styleProps, {
      children: Pricing
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Term",
      paddingBlockStart: Term ? '250' : '0'
    }, layoutProps, styleProps, {
      children: Term
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "CTAs",
      paddingBlockStart: "500"
    }, layoutProps, styleProps, {
      children: CTAs
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Subtext",
      paddingBlockStart: Subtext ? '800' : '0'
    }, layoutProps, styleProps, {
      children: Subtext
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Features",
      paddingBlockStart: "700"
    }, layoutProps, styleProps, {
      children: Features
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({
      gridArea: "Footer",
      paddingBlockStart: "600",
      paddingBlockEnd: "1000",
      borderBlockEndStyle: showBorder ? 'solid' : 'none',
      borderEndStartRadius: radius,
      borderEndEndRadius: radius
    }, layoutProps, styleProps, {
      children: Footer
    }))]
  });
};
export default HSOCMerchCardLayoutUI;